<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { sDs } from "@common/sDs/sDs";
import { uStore } from "@common/userStore";
import { ddStore } from "@common/ddStore";

let vmsChooseMyOrganizationConfig = {
    cId: "vmsChooseMyOrganization",
    cType: "vmsChooseMyOrganization",
    cTitle: "Choose My Organization",
    cTemplate: `<div :id="wrapperID" class="vmsChooseMyOrganization-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsChooseMyOrganization-title">Choose My Organization</div>
                    <div class="vmsChooseMyOrganization-subTitle">
                        <span>Please select an organization to assign as My Organization</span>
                    </div>
                    <div v-if="typeof currentMyOrg === 'object' && currentMyOrg" class="vmsChooseMyOrganization-currentOrgTitle">
                        {{currentMyOrg.ORG_TITLE}}
                    </div>
                    <div class="vmsChooseMyOrganization-orgsWrapper">
                        <div class="vmsChooseMyOrganization-orgList-header">
                            <span>Available organizations</span>
                        </div>
                        <control name="ORG_LIST" :items="orgList" class="vmsChooseMyOrganization-orgList-control"></control>
                    </div>
                    <div v-if="totalPages > 1" class="vmsChooseMyOrganization-navigatorInfo">
                        <div class="vmsChooseMyOrganization-navigatorRecords">
                            <span>{{recordPositionFrom}} to {{recordPositionTo}} of {{recordCount}} Records</span>
                        </div>
                        <div class="vmsChooseMyOrganization-navigator control-section">
                            <span>Page {{currentPage}} of {{totalPages}}</span>
                            <a class="vmsChooseMyOrganization-navigator-pages" href="javascript:void(0)" @click="goToPage(1)">
                                <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeftDisabled.gif'" alt="Go to the first page">
                                <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeft.gif'" alt="Go to the first page">
                            </a>
                            <a class="vmsChooseMyOrganization-navigator-pages" href="javascript:void(0)" @click="goToPage(currentPage - 1)">
                                <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowLeftDisabled.gif'" alt="Go to previous page">
                                <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowLeft.gif'" alt="Go to previous page">
                            </a>
                            <input :ref="'pageInput'" type="text" size="3" aria-label="page number" maxlength="10" class="vmsChooseMyOrganization-navigator-pages gridEngineNavigator" @keydown="goToPagePressEnter" :value="currentPage">
                            <a class="vmsChooseMyOrganization-navigator-pages" href="javascript:void(0)" @click="goToPage(currentPage + 1)">
                                <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowRightDisabled.gif'" alt="Go to next page">
                                <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowRight.gif'" alt="Go to next page">
                            </a>
                            <a class="vmsChooseMyOrganization-navigator-pages" href="javascript:void(0)" @click="goToPage(totalPages)">
                                <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRightDisabled.gif'" alt="Go to the last page">
                                <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRight.gif'" alt="Go to the last page">
                            </a>
                        </div>
                    </div>
                    <div>
                        <span class="vmsChooseMyOrganization-searchTitle">Find results for...</span>
                        <div class="vmsChooseMyOrganization-searchWrapper">
                            <control name="CHOOSE_MY_ORGANIZATION_SEARCH" @keydown="searchPressEnter"></control>
                            <control name="CHOOSE_MY_ORGANIZATION_FIND_BUTTON" class="findControl"></control>
                            <control name="CHOOSE_MY_ORGANIZATION_SHOW_ALL_BUTTON" class="showAllControl"></control>
                        </div>
                    </div>
                    <div class="vmsChooseMyOrganization-buttons">
                        <div class="vmsChooseMyOrganization-button"><control name="CHOOSE_MY_ORGANIZATION_OK_BUTTON"></control></div>
                        <div class="vmsChooseMyOrganization-button"><control name="CHOOSE_MY_ORGANIZATION_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'ORG_LIST',
            type: 'list',
            onclick: 'selectOrg',
            itemContentTemplate: `
                <div class="vmsChooseMyOrganization-org">
                    <div class="vmsChooseMyOrganization-org-cell">
                        <div class="vmsChooseMyOrganization-org-cell-whiteSpace">
                            <div v-if="component.getSelectOrgId() === data.ORGANIZATION_ID" class="vmsChooseMyOrganization-org-cell-isActive"></div>
                        </div>
                        {{data.ORG_TITLE}}
                    </div>
                </div>
                `,
            components: {
                "ejs-radiobutton": defineAsyncComponent(() => import('@common/syncfusion/radioButton')),
            }
        },
        {
            name: 'CHOOSE_MY_ORGANIZATION_SEARCH',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChooseMyOrganizationSearch'
        },
        {
            name: 'CHOOSE_MY_ORGANIZATION_FIND_BUTTON',
            type: 'button',
            label: 'Find',
            onclick: 'findOrg',
        },
        {
            name: 'CHOOSE_MY_ORGANIZATION_SHOW_ALL_BUTTON',
            type: 'button',
            label: 'Show All',
            onclick: 'showAll',
        },
        {
            name: 'CHOOSE_MY_ORGANIZATION_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CHOOSE_MY_ORGANIZATION_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsChooseMyOrganizationCmp = {
    name: 'vmsChooseMyOrganization',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        }
    },
    data() {
        return {
            currentMyOrg: null,
            selectOrgId: null,
            currentPage: 1,
            totalPages: 1,
            recordPositionFrom: 0,
            recordPositionTo: 0,
            recordCount: 0,
            searchQuery: null,
            orgList: []
        };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        },
        projectUrl() {
            return typeof PROJECTS_URL !== 'undefined' ? PROJECTS_URL : '/';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        onLoad() {
            this.$emit('update:vmsChooseMyOrganizationLoaded', true);
            library.showLoadingIndicator(this.wrapperID);
            this.getMyAvailableOrganizations(this.currentPage).then(() => {
                library.hideLoadingIndicator(this.wrapperID);
            });
            uStore().getUserOrganization().then((userOrg) => {
                if (typeof userOrg === 'object' && userOrg) {
                    this.currentMyOrg = library.cloneObj(userOrg);
                }
            });
        },
        getSelectOrgId() {
            return this.selectOrgId ?? (typeof this.currentMyOrg === 'object' && this.currentMyOrg ? this.currentMyOrg.ORGANIZATION_ID : null);
        },
        async selectOrg(orgInfo) {
            this.selectOrgId = orgInfo.ORGANIZATION_ID;
        },
        async searchPressEnter(event) {
            if (event && event.keyCode === 13) {
                event.stopImmediatePropagation();
                await this.findOrg();
            }
        },
        async getMyAvailableOrganizations(pageNumber, searchQuery = null) {
            if (typeof pageNumber !== 'number' || pageNumber < 1) {
                pageNumber = 1;
            }
            if (searchQuery !== null && typeof searchQuery !== 'string') {
                searchQuery = null;
            } else {
                searchQuery = searchQuery?.trim();
            }
            let response = await sDs.post('ec_getMyAvailableOrganizations', pageNumber, searchQuery);
            if (response && response.status === 'success' && response.data) {
                if (typeof response.data.currentPage !== 'undefined') {
                    this.currentPage = response.data.currentPage;
                }
                if (typeof response.data.totalPages !== 'undefined') {
                    this.totalPages = response.data.totalPages;
                }
                if (typeof response.data.recordPositionFrom !== 'undefined') {
                    this.recordPositionFrom = response.data.recordPositionFrom;
                }
                if (typeof response.data.recordPositionTo !== 'undefined') {
                    this.recordPositionTo = response.data.recordPositionTo;
                }
                if (typeof response.data.recordCount !== 'undefined') {
                    this.recordCount = response.data.recordCount;
                }
                if (typeof response.data.searchQuery !== 'undefined') {
                    this.searchQuery = response.data.searchQuery;
                }
                if (typeof response.data.orgList === 'object') {
                    this.orgList = library.cloneObj(response.data.orgList);
                }
                this.selectOrgId = null;
            }
        },
        async findOrg() {
            let searchQuery = this.refs['vmsChooseMyOrganizationSearch'].value.trim();
            if (!searchQuery.length) {
                await this.showAll();
                return;
            }
            library.showLoadingIndicator(this.wrapperID);
            await this.getMyAvailableOrganizations(1, searchQuery);
            library.hideLoadingIndicator(this.wrapperID);
        },
        async showAll() {
            library.showLoadingIndicator(this.wrapperID);
            this.refs['vmsChooseMyOrganizationSearch'].value = '';
            await this.getMyAvailableOrganizations(1);
            library.hideLoadingIndicator(this.wrapperID);
        },
        async goToPage(pageNumber) {
            if (pageNumber === this.currentPage || pageNumber < 1 || pageNumber > this.totalPages) {
                return;
            }
            let searchQuery = this.searchQuery;
            library.showLoadingIndicator(this.wrapperID);
            await this.getMyAvailableOrganizations(pageNumber, searchQuery);
            library.hideLoadingIndicator(this.wrapperID);
        },
        async goToPagePressEnter(event) {
            if (event && event.keyCode === 13) {
                event.stopImmediatePropagation();
                let pageNumber = parseInt(this.$refs['pageInput'].value, 10);
                await this.goToPage(pageNumber);
            }
        },
        async save() {
            let selectOrgId = this.selectOrgId;
            if (this.selectOrgId) {
                library.showLoadingIndicator(this.wrapperID);
                let response = await sDs.post('ec_setMyOrganizationId', selectOrgId);
                library.hideLoadingIndicator(this.wrapperID);
                if (response && response.status === 'success') {
                    this.close();
                } else if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsChooseMyOrganizationSaveWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                }
            } else {
                this.close();
            }
        },
        close() {
            if (/openvmsChooseMyOrganization/g.test(window.name)) {
                window.close();
            } else if (
                this.$parent && this.$parent.$parent
                && this.$parent.$parent.$parent
                && typeof this.$parent.$parent.$parent.componentDialogs === 'object'
                && this.$parent.$parent.$parent.componentDialogs.length
            ) {
                this.$parent.$parent.$parent.componentDialogs.find((component) => component.name === 'openvmsChooseMyOrganization')?.cancelButton?.click();
            }
        }
    }
};

componentStore.initComponent(vmsChooseMyOrganizationCmp, vmsChooseMyOrganizationConfig);
export { vmsChooseMyOrganizationConfig, vmsChooseMyOrganizationCmp };
export default vmsChooseMyOrganizationCmp;
</script>

<style>
#dialog_container_openvmsChooseMyOrganization, #dialog_container_openvmsChooseMyOrganization > div {
    height: 400px;
}
</style>
<style scoped>
:deep(.vmsChooseMyOrganization-title) {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
:deep(.vmsChooseMyOrganization-subTitle) {
    text-align: center;
    margin-top: 10px;
}
:deep(.vmsChooseMyOrganization-currentOrgTitle) {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
}
:deep(.vmsChooseMyOrganization-orgsWrapper) {
    margin-top: 10px;
    width: 100%;
}
:deep(.vmsChooseMyOrganization-orgList-header) {
    background: #cfd8dc;
    padding: 5px;
}
:deep(.vmsChooseMyOrganization-orgList-header span) {
    font-weight: bold;
    font-size: 13px;
    margin-left: 25px;
}
:deep(.vmsChooseMyOrganization-orgList-control) {
    height: 200px;
    overflow-y: auto;
}
:deep(.vmsChooseMyOrganization-org) {
    width: 100%;
    min-height: 30px;
    padding: 5px;
    display: flex;
    font-size: 16px;
    cursor: pointer;
    border-bottom: 1px solid #dadce0;
}
:deep(.vmsChooseMyOrganization-org:hover) {
    background:#e8f0fe;
}
:deep(.vmsChooseMyOrganization-org-cell) {
    margin: 0 5px;
    display: inline-flex;
    align-items: center;
}
:deep(.vmsChooseMyOrganization-org-cell-whiteSpace) {
    width: 12px;
    margin-right: 10px;
}
:deep(.vmsChooseMyOrganization-org-cell-isActive) {
    width: 12px;
    height: 12px;
    background: #1976d2;
    border-radius: 50%;
}
:deep(.vmsChooseMyOrganization-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.vmsChooseMyOrganization-searchTitle) {
    font-weight: 600;
}
:deep(.vmsChooseMyOrganization-searchWrapper) {
    display: flex;
}
:deep(.vmsChooseMyOrganization-searchWrapper .findControl) {
    min-width: 90px;
    margin: 0 10px;
}
:deep(.vmsChooseMyOrganization-searchWrapper .showAllControl) {
    min-width: 90px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsChooseMyOrganization-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsChooseMyOrganization-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
:deep(.vmsChooseMyOrganization-navigatorInfo) {
    margin: 10px 0;
    align-items: center;
    font-weight: 600;
    text-align: center;
}
:deep(.vmsChooseMyOrganization-navigatorRecords) {
    display: inline-flex;
}
:deep(.vmsChooseMyOrganization-navigator.control-section) {
    margin-left: 20px;
    line-height: 27px;
    display: inline-flex;
}
:deep(.vmsChooseMyOrganization-navigator-pages) {
    margin: 0 5px;
    text-align: center;
    cursor: pointer;
}
</style>
